<template>
  <div class="clientManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-clientManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">客户管理</span>
              <div class="pull-right">
                <!-- *************暂时隐藏***************** -->
                 <el-button type="primary" @click="daochu">{{$t('Common.btn_export')}}</el-button>
              </div>
            </div>
          </div>
          <div class="clientManage-container">
            <div class="content">
              <div class="content-nav--head text-1">
                <!-- <div class="c-n--head_lf">
                  <span class="mr10">已报名名单</span>
                </div>-->
                <div class="c-n--head_lf">
                  <!-- <div class="head-right">主责任人：
                    <el-select filterable
                      v-model="selectForm.chiefPerson"
                      class="mr15"
                      style="width: 150px;"
                      clearable
                      placeholder="选择主负责人"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="head-right">协助负责人：
                    <el-select filterable
                      v-model="selectForm.chiefPerson_fu"
                      class="mr15"
                      style="width: 150px;"
                      clearable
                      placeholder="选择协助负责人"
                      @change="handleSelect()"
                    >
                      <el-option
                      v-for="item in chiefPerson"
                      :key="item.marketer_id"
                      :label="item.marketer_name"
                      :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="head-right">报名课程：
                    <el-select filterable
                      v-model="selectForm.course"
                      class="mr15"
                      style="width: 150px;"
                      clearable
                      placeholder="请选择报名课程"
                       @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in SchoolCourseOption"
                        :key="item.coursecat_id"
                        :label="item.coursecat_cnname"
                        :value="item.coursecat_id"
                      ></el-option>
                    </el-select>
                  </div>-->

                  <el-input clearable
                    placeholder="请输入中/英文名、手机号"
                    class="input-cont input-keword"
                    @change="handleSelectKeyword()"
                    v-model="selectForm.keyword"
                  ></el-input>
                  <el-button type="primary" class="btn-inquire" @click="handleSelectKeyword()">查询</el-button>
                  <!-- <div class="btn-advancedFiter font-gray">
                    <i class="fiter-advance">
                      <img src="../../assets/images/filter.png" alt>
                    </i>
                    高级筛选
                  </div>-->
                  <!-- <el-button type="primary">转回招生线索</el-button> -->
                </div>
              </div>

              <TableList
                :list="tableData"
                :options="optionscaozuo"
                :columns="columns"
                :operates="operates"
                :issetting="true"
                :tableOperate="tableOperate"
                @toggleEditableColumn="toggleEditableColumn"
              ></TableList>

              <el-pagination
                style="margin-top: 35px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30,40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
          <!-- 编辑列 -->
          <el-dialog
            title="编辑列"
            class="setting-column"
            :visible.sync="settingVisible"
            width="450px"
            :before-close="handleClose"
          >
            <el-transfer
              :titles="['已显示列', '未显示的列']"
              v-model="oprateColumn"
              @change="Changeoprate()"
              :data="data"
            ></el-transfer>
            <div class="oprate">
              <el-button type="primary" size="small" @click="handClickOprate()">确定</el-button>
            </div>
          </el-dialog>
          <!-- 分配学校 -->
          <el-dialog
            title="选择学校"
            :visible.sync="dealSchoolVisible"
            width="900px"
            :before-close="handleClose"
            class="chooseSchool"
          >
            <div class="chooseSchool-tabs">
              <div class="select-school">
                <el-input clearable
                    placeholder="请输入学校中/英文名、学校编号"
                    class="input-cont input-keword"
                    @change="SelectSchoolKeyword()"
                    v-model="schoolTable.selectForm.keyword"
                    style="width:220px;padding-bottom:20px;padding-top:20px;"
                  ></el-input>
                  <el-button type="primary" class="btn-inquire" @click="SelectSchoolKeyword()">查询</el-button>
              </div>
              <div class="formal-table">
                <el-table stripe :data="schoolTable.changeFormalData" height="300px">
                  <!-- 暂无数据提示，自己定义就OK了 -->
                  <template slot="empty">
                    <div class="no-data">
                        <i class="crm-wu"></i>
                        <span class="text-1">暂无数据</span>
                    </div>
                  </template>
                  <!--region 选择框-->
                  <el-table-column
                    v-if="schoolTable.optionFormal.RadioSelect"
                    style="width: 30px;"
                    min-width="30px"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-radio
                        v-model="radio"
                        :label="scope.$index"
                        @change="singleBox(scope.row)"
                      >{{''}}</el-radio>
                    </template>
                  </el-table-column>
                  <template v-for="(column,index) in schoolTable.columnsFormal">
                    <el-table-column
                      :prop="column.fieldname"
                      :key="index"
                      :label="column.fieldstring"
                      align="center"
                      v-if="column.show=='1'"
                    ></el-table-column>
                  </template>
                </el-table>
                <el-pagination
                  @size-change="handleSchoolSizeChange" 
                  @current-change="handleSchoolCurrentChange" 
                  :current-page="schoolTable.currentPage" 
                  :page-sizes="[10, 20, 30,40]" 
                  :page-size="schoolTable.pageSize" 
                  layout="total, sizes, prev, pager, next, jumper" 
                  :total="schoolTable.dataNumber">
                </el-pagination>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button plain size="mini" @click="dealSchoolVisible=false">取消</el-button>
              <el-button type="primary" size="mini" @click="dealSchoolSubmit()">确定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
// import echarts from "echarts";
// import SliderBox from "../../components/SliderBox";
import TableList from "../../components/Table/table.vue";
import storeClientManage from "./clientManage.js";
export default {
  name: "ClientManage-clientManage",
  data() {
    return {
      openMenu: ["7"],
      showSliderBox: false,
      fullscreenLoading: true, //全屏loading
      settingVisible: false,
      dealSchoolVisible: false,//分配学校
      SchoolInfo:"",//分配的学校
      radio: "", //单选按钮绑定值
      activity_id:"",//单个活动id
      client_id:"",//单个客户id
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      data: [],
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      selectForm: {
        course: "",
        chiefPerson: "",
        chiefPerson_fu: "",
        keyword: ""
      },
      SchoolCourseOption: [],
      chiefPerson: [],

      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "600px", //侧边栏宽度
      activeName: "first",
      // 侧边栏 资料建档
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        }
      ],

      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: Number //表格高度
        // specialColumns:true//特殊列
      },
      columns: [],
      allColumns: [],
      operates: {
        width: 150,
        label: "操作",
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: "分配",
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              (() => {})(row);
              // 数据清空
              this.SchoolInfo="";//分配的学校
              this.radio=""; //单选按钮绑定值
              this.schoolTable.selectForm.keyword="";
              this.dealSchoolVisible=true;
              this.activity_id=row.activity_id;
              this.client_id=row.client_id;
              this.getSchoolByActivityData(row.activity_id);
              // this.handleOneClick(row);
            }
          }
        ]
      }, // 列操作按钮
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right"
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 分配学校*******表格
      schoolTable: {
        //选择学校-表格数据
        changeFormalData: [
          {
            date1:"华江",
            date2:"华江",
            date3:"华江",
          }
        ],
        optionFormal: {
          stripe: true,
          mutiSelect: false, // 是否支持列表项选中功能
          highlightCurrentRow: true, // 是否支持当前行高亮显示
          RadioSelect: true
        },
        columnsFormal: [
          {
            fieldstring:"date1",
            fieldname:"学校名称",
            show:"1",
          },
           {
            fieldstring:"date2",
            fieldname:"学校编号",
            show:"1",
          },
           {
            fieldstring:"date3",
            fieldname:"学校地址",
            show:"1",
          },
        ],
        // 列操作按钮,
        operatesFormal: {
          width: 200,
          label: "时间安排",
          align: "center",
          fixed: "right",
          list: []
        },
        //筛选条件
        selectForm: {
          keyword: ""
        },
        // 分页的数据
        dataNumber: 0, //数据总数
        pagenum: "1",
        pagesize: 10,
      },
    };
  },
  components: {
    PageNav,
    TableList
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";

    this.getCompanyClientData(this.pagenum);
    this.optionscaozuo.tableHeight = this.$Common.getTableHeight(330); //设置表格高度
  },
  mounted() {},
  methods: {
    // 客户管理表格数据
    getCompanyClientData(page) {
      storeClientManage
        .getCompanyClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          // 非必须传
          // main_marketer_id: this.selectForm.chiefPerson,
          // fu_marketer_id: this.selectForm.chiefPerson_fu,
          // course_id: this.selectForm.course,
          keyword: this.selectForm.keyword
        })
        .then(res => {
          // 
          this.tableData = res.data.data.list;
          this.dataNumber = parseInt(res.data.data.allnum);
         
          var Columns = res.data.data.field;
          this.allColumns = res.data.data.field;
          this.$Tool.setStorage("allclientColumns", this.allColumns);
          this.showColumn = JSON.parse(
            localStorage.getItem("showclientColumns")
          );
          var fieldColumns = res.data.data.field;
          if (JSON.parse(localStorage.getItem("showclientColumns"))) {
            Columns = this.showColumn;
            fieldColumns = this.showColumn;
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            -1
          );
          this.columns[2].isfixed = true;
          this.columns[2].fixed = "left";
          this.optionscaozuo.loading = false;
          var arr = [];
          var arr2 = [];
          fieldColumns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0"
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
          (() => {})(this.columns);
        });
    },
    //  客户管理->获取该活动参与的学校
    getSchoolByActivityData(activity_id) {
      // SchoolClassOption
      storeClientManage
        .getSchoolByActivity({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          activity_id:activity_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.schoolTable.currentPage,
          num: this.schoolTable.pagesize,
          keyword: this.schoolTable.selectForm.keyword
        })
        .then(res => {
          this.schoolTable.columnsFormal = res.data.data.field;
          if(res.data.code === 200){
            this.schoolTable.changeFormalData= res.data.data.list;
            this.schoolTable.dataNumber = parseInt(res.data.data.allnum); 
          }else{
            this.schoolTable.changeFormalData=[];
          }
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeClientManage
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id
        })
        .then(res => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          this.chiefPerson.unshift({
            marketer_id: "",
            marketer_name: "不限"
          });
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getCompanyClientData(this.pagenum);
    },
    // 分配学校关键词的查询
    SelectSchoolKeyword(){
       this.getSchoolByActivityData(this.activity_id);
    },
    //分配学校单选
    singleBox(val) {
      this.SchoolInfo=val;
      (() => {})(this.SchoolInfo)
    },
    // 分配学校提交
    dealSchoolSubmit(){
      (() => {})(this.SchoolInfo)
      if(this.SchoolInfo!=""){
        storeClientManage
        .allotSchool({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id:this.client_id,
          re_school_id:this.SchoolInfo.school_id
        })
        .then(res => {
          if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success"
          });
          this.getCompanyClientData(this.pagenum);
          this.dealSchoolVisible=false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
        });
      }else{
        this.$message({
            message: "请选择学校",
            type: "error"
          });
      }
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getCompanyClientData(this.pagenum);
    },
    // 编辑列
    Changeoprate() {
      (() => {})("列变化");
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allclientColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item, index) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showclientColumns", this.showColumns);
      this.settingVisible = false;
      this.getCompanyClientData(this.pagenum);
      (() => {})(allnum);
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    onSubmit() {
      (() => {})(this.form);
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(tab, event) {
      (() => {})(tab, event);
    },
    handleOneClick(v1) {
      this.visitedJG = true;
      (() => {})(v1);
    },
    handleTwoClick(v1) {
      this.visitingJG = true;
      (() => {})(v1);
    },
    handleClick(v) {
      this.showSliderBox = true;
      (() => {})(v);
      //  this.canvasWidth();
      //  this.comparedDrawLine();
      // this.$message({
      //   message: `123232421432535`,
      //   type: 'success'
      // })
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          (() => {})(_);
          done();
        })
        .catch(_ => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.getCompanyClientData(this.pagenum);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.getCompanyClientData(val);
    },
    // 分配学校分页
    handleSchoolSizeChange(val) {
      this.schoolTable.pagesize = val;
      this.getSchoolByActivityData(this.activity_id);
    },
    handleSchoolCurrentChange(val) {
      this.schoolTable.currentPage = val;
      this.getSchoolByActivityData(this.activity_id);
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
     // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      for (name in this.selectForm) {
        if (name != "rang_time") {
          // 时间范围不需要
          params_str = params_str + `&${name}=${this.selectForm[name]}`;
        }
      }
      let url = storeClientManage.getCompanyClient1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    }
  }
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("clientManage.less");
.clientManage {
  height: 100vh;
  font-size: 20px;
}
</style>
